import { centsToDollars, formatDollars, isEmpty } from '@fruitful/fruitils';
import type { DepositAccount } from '@fruitful/types';
import * as React from 'react';
import {
    BodyMediumEmphasized,
    ChevronRightIcon,
    FootnoteRegular,
    FruitfulCustomIcon,
    Icon,
    InstitutionLogo,
    Private,
    XStack,
    YStack,
} from 'smoothie';

interface TransferAccountLineItemProps {
    onPress?: () => void;
    depositAccount?: DepositAccount | null;
    placeholder?: string;
    showActionIcon?: boolean;
}

// TODO jason
//   Move to shared package _after_ IM launch

const TransferAccountLineItem = ({
    depositAccount,
    onPress,
    placeholder,
    showActionIcon,
}: TransferAccountLineItemProps) => {
    const {
        imgBase64,
        logo,
        icon,
        color,
        bankName,
        accountNumberMasked,
        availableBalance,
    } = depositAccount ?? {};

    const getNormalizedDepositAccountNickname = (
        depositAccount: DepositAccount,
    ): string => {
        const { accountType, nickname } = depositAccount;
        return !isEmpty(nickname) && !nickname.includes('Plaid')
            ? nickname
            : accountType;
    };

    return (
        <XStack
            alignItems="center"
            justifyContent="space-between"
            gap={16}
            onPress={onPress}
            cursor="pointer"
            hoverStyle={{ backgroundColor: '$gray100' }}
            $sm={{ padding: 8, borderRadius: 12 }}
        >
            <XStack
                alignItems="center"
                gap={16}
                flexShrink={1}
                $platform-web={{ flexGrow: 1 }}
            >
                {bankName === 'Fruitful' ? (
                    <FruitfulCustomIcon icon={icon} color={color} />
                ) : (
                    <InstitutionLogo logo={logo ?? imgBase64} />
                )}

                {depositAccount != null ? (
                    <XStack
                        flex={1}
                        alignItems="center"
                        justifyContent="space-between"
                    >
                        <YStack flex={1}>
                            <BodyMediumEmphasized>
                                {getNormalizedDepositAccountNickname(
                                    depositAccount,
                                )}
                            </BodyMediumEmphasized>
                            <XStack alignItems="center" gap={8}>
                                {(!isEmpty(bankName) ||
                                    !isEmpty(accountNumberMasked)) && (
                                    <FootnoteRegular color="$gray1000">
                                        {bankName} *{accountNumberMasked}
                                    </FootnoteRegular>
                                )}
                            </XStack>
                        </YStack>
                        <Private>
                            <BodyMediumEmphasized>
                                {availableBalance != null
                                    ? formatDollars(
                                          centsToDollars(availableBalance),
                                      )
                                    : ''}
                            </BodyMediumEmphasized>
                        </Private>
                    </XStack>
                ) : (
                    <BodyMediumEmphasized>{placeholder}</BodyMediumEmphasized>
                )}
            </XStack>
            {showActionIcon && <Icon icon={ChevronRightIcon} size={16} />}
        </XStack>
    );
};

export default TransferAccountLineItem;
